<template>
  <v-dialog v-model="dialog" max-width="900px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="info"
        x-small
        class="mr-2"
        title="Historial de Requisiciones"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon small>mdi-history</v-icon>
      </v-btn>
    </template>

    <v-card>
      <!-- Header del modal -->
      <v-card-title class="headline primary white--text">
        Historial del Servicio
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-4">
        <v-row>
        <!-- Sección 1: Información básica del servicio -->
        <v-col cols="12">
          <v-card outlined>
            <v-card-text>
              <div class="text-h6 mb-2">Información del Servicio</div>
              <v-row>
                <v-col cols="4">
                  <div class="caption grey--text">Servicio</div>
                  <div class="subtitle-1">{{ servicio.egreso_programado }}</div>
                </v-col>
                <v-col cols="4">
                  <div class="caption grey--text">No. Servicio</div>
                  <div class="subtitle-1">{{ servicio.cuenta }}</div>
                </v-col>
                <v-col cols="4">
                  <div class="caption grey--text">Recurrencia</div>
                  <div class="subtitle-1">
                    <v-chip small color="primary" text-color="white">
                      {{ getRecurrenciaText(servicio.recurrencia) }}
                    </v-chip>
                  </div>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="4">
                  <div class="caption grey--text">Monto Solicitado</div>
                  <div class="subtitle-1">${{ servicio.monto_solicitado.toLocaleString('es-MX', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</div>
                </v-col>
                <!-- <v-col cols="4">
                  <div class="caption grey--text">Proveedor</div>
                  <div class="subtitle-1 d-flex align-center">
                    {{ getProveedorNombre(servicio.idproveedores) }}
                    <v-btn
                      x-small
                      color="light-blue darken-1"
                      @click="visualizarDocumentoProveedor"
                      class="ml-2"
                      title="Ver instrucciones de pago"
                      fab
                      elevation="2"
                      v-if="tieneDocumento(servicio.idproveedores)"
                    >
                      <v-icon small>mdi-file-document-outline</v-icon>
                    </v-btn>
                  </div>
                </v-col> -->
                <v-col cols="4">
                  <div class="caption grey--text">Plantel</div>
                  <div class="subtitle-1">{{ getPlantelNombre(servicio.id_plantel) }}</div>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="4">
                  <div class="caption grey--text">Fecha Vencimiento</div>
                  <div class="subtitle-1">{{ servicio.fecha_vencimiento || 'No especificada' }}</div>
                </v-col>
                <v-col cols="4">
                  <div class="caption grey--text">Estado</div>
                  <div class="subtitle-1">
                    <v-chip small :color="servicio.activo_sn ? 'green' : 'red'" text-color="white">
                      {{ servicio.activo_sn ? 'Activo' : 'Inactivo' }}
                    </v-chip>
                  </div>
                </v-col>
                <v-col cols="4">
                  <div class="caption grey--text">Categoría</div>
                  <div class="subtitle-1">{{ getCategoriaText(servicio.id_tipo_elemento) }}</div>
                </v-col>
              </v-row>

              <v-row v-if="servicio.comentarios">
                <v-col cols="12">
                  <div class="caption grey--text">Comentarios</div>
                  <div class="subtitle-1">{{ servicio.comentarios }}</div>
                </v-col>
              </v-row>
              <v-row v-if="servicio.idproveedores">
                <v-col cols="4">
                  <div class="caption grey--text">Proveedor</div>
                  <div class="subtitle-1">{{ getProveedorNombre(servicio.idproveedores) }}</div>
                </v-col>
                <v-col cols="8" v-if="tieneDocumento(servicio.idproveedores)">
                  <div class="caption grey--text d-flex align-center">
                    Instrucciones de pago
                    <v-btn
                      icon
                      small
                      class="ml-2"
                      @click="togglePreview"
                      :disabled="cargandoPreview"
                      :title="previewExpanded ? 'Minimizar' : 'Expandir'"
                    >
                      <v-icon small>{{ previewExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                    <v-progress-circular
                      indeterminate
                      size="20"
                      width="2"
                      class="ml-2"
                      v-if="cargandoPreview"
                    ></v-progress-circular>
                  </div>

                  <div v-show="previewExpanded" class="pdf-preview-container mt-2">
                    <iframe
                      v-if="pdfUrl"
                      :src="pdfUrl"
                      class="pdf-preview"
                      width="100%"
                      height="300"
                      frameborder="0"
                    ></iframe>
                    <div v-else-if="!cargandoPreview" class="py-5 text-center grey--text">
                      No se pudo cargar el documento
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
          <!-- Componente para pagos programados -->
          <v-col cols="12">
            <pagos-programados
              :servicio="servicio"
              @mostrar-exito="mostrarExito"
              @mostrar-error="mostrarError"
              @generar-requisicion="generarRequisicionDesdePrograma"
              ref="pagosComponent"
            />
          </v-col>

          <!-- Componente para requisiciones -->
          <v-col cols="12">
            <generar-requisiciones
              :servicio="servicio"
              @mostrar-exito="mostrarExito"
              @mostrar-error="mostrarError"
              ref="requisicionesComponent"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- Visor de PDF -->
    <PDFViewer
      :dialog.sync="dialogPdf"
      :pdf-url="pdfUrl"
      :file-name="'documento-proveedor-' + (servicio.idproveedores || '0') + '.pdf'"
    />
  </v-dialog>
</template>

<script>
import GenerarRequisiciones from './GenerarRequisiciones.vue'
import PagosProgramados from './PagosProgramados.vue'
import PDFViewer from '@/components/PDFViewer.vue'

export default {
  name: 'HistorialRequisiciones',

  components: {
    GenerarRequisiciones,
    PagosProgramados,
    PDFViewer
  },

  props: {
    servicio: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    dialog: false,
    proveedores: [],
    planteles: [],
    categorias: [],

    dialogPdf: false,
    pdfUrl: null,
    selectedProveedor: null,
    cargar: false,

    previewExpanded: true,
    cargandoPreview: false,
  }),

  created() {
    // Cargar listas de proveedores, planteles y categorías cuando se crea el componente
    this.cargarProveedores();
    this.cargarPlanteles();
    this.cargarCategorias();
  },

  methods: {
    cargarDocumentoProveedor() {
      const idproveedor = this.servicio.idproveedores;
      if (!idproveedor) {
        this.$emit('mostrar-error', 'No hay un proveedor asociado a este servicio');
        return;
      }

      this.cargandoPreview = true;
      this.selectedProveedor = this.proveedores.find(p => p.idproveedores === idproveedor);

      // Obtener la URL base
      let baseURL = this.$http.defaults.baseURL;
      if (baseURL.endsWith('/')) {
        baseURL = baseURL.slice(0, -1);
      }

      const url = `${baseURL}/proveedores.download.documento/${idproveedor}`;
      return
      // // Us  ar axios para obtener el documento
      // this.$http({
      //   url: url,
      //   method: 'GET',
      //   responseType: 'blob',
      // })
      // .then(response => {
      //   const blob = new Blob([response.data], { type: 'application/pdf' });
      //   this.pdfUrl = window.URL.createObjectURL(blob);
      // })
      // .catch(error => {
      //   console.error('Error al cargar el documento:', error);
      //   this.$emit('mostrar-error', 'Error al cargar el documento. Por favor, inténtelo de nuevo.');
      // })
      // .finally(() => {
      //   this.cargandoPreview = false;
      // });
    },

    togglePreview() {
      this.previewExpanded = !this.previewExpanded;

      // Si estamos expandiendo y no se ha cargado el PDF, lo cargamos
      if (this.previewExpanded && !this.pdfUrl && !this.cargandoPreview) {
        this.cargarDocumentoProveedor();
      }
    },

    cargarVistaPrevia() {
      if (this.cargandoPreview) return;

      const idproveedor = this.servicio.idproveedores;
      if (!idproveedor) {
        this.$emit('mostrar-error', 'No hay un proveedor asociado a este servicio');
        return;
      }

      this.cargandoPreview = true;
      this.selectedProveedor = this.proveedores.find(p => p.idproveedores === idproveedor);

      // Obtener la URL base
      let baseURL = this.$http.defaults.baseURL;
      if (baseURL.endsWith('/')) {
        baseURL = baseURL.slice(0, -1);
      }

      const url = `${baseURL}/proveedores.download.documento/${idproveedor}`;
      return
      // // Usar axios para obtener el documento
      // this.$http({
      //   url: url,
      //   method: 'GET',
      //   responseType: 'blob',
      // })
      // .then(response => {
      //   const blob = new Blob([response.data], { type: 'application/pdf' });
      //   this.pdfUrl = window.URL.createObjectURL(blob);
      //   this.previewLoaded = true;
      // })
      // .catch(error => {
      //   console.error('Error al cargar el documento:', error);
      //   this.$emit('mostrar-error', 'Error al cargar el documento. Por favor, inténtelo de nuevo.');
      // })
      // .finally(() => {
      //   this.cargandoPreview = false;
      // });
    },

    generarRequisicionDesdePrograma(pago) {

      // Llama al método del componente hijo pasándole el pago
      if (this.$refs.requisicionesComponent) {
        // console.log('Componente Padre: Llamando a generarRequiDesdePrograma en el hijo');
        this.$refs.requisicionesComponent.generarRequiDesdePrograma(pago);
      }else {
        // console.error('Componente Padre: Referencia a GenerarRequisiciones no disponible');
      }
    },

    getRecurrenciaText(value) {
      const recurrencias = {
        0: "No Aplica",
        1: "Diario",
        2: "Mensual",
        3: "Bimestral",
        4: "Anual",
        5: "Catorcenal",
        6: "Semanal"
      };
      return recurrencias[value] || "No especificado";
    },

    // Método para obtener el nombre del proveedor
    getProveedorNombre(idproveedor) {
      if (!idproveedor) return 'No especificado';
      const proveedor = this.proveedores.find(p => p.idproveedores === idproveedor);
      return proveedor ? proveedor.nombre_comercial : 'No especificado';
    },

    // Método para obtener el nombre del plantel
    getPlantelNombre(idplantel) {
      if (!idplantel) return 'No especificado';
      const plantel = this.planteles.find(p => p.id_plantel === idplantel);
      return plantel ? plantel.plantel : 'No especificado';
    },

    // Método para obtener el nombre de la categoría
    getCategoriaText(idtipo) {
      if (!idtipo) return 'No especificada';
      const categoria = this.categorias.find(c => c.idtipo_requisiciones === idtipo);
      return categoria ? categoria.tipo_requisicion : 'No especificada';
    },

    // Métodos para cargar datos necesarios
    async cargarProveedores() {
      try {
        const response = await this.$http.get("proveedores.list.erp");
        this.proveedores = response.data;
      } catch (error) {
        console.error("Error al cargar proveedores:", error);
      }
    },

    async cargarPlanteles() {
      try {
        const response = await this.$http.get("planteles.list.erp");
        this.planteles = response.data;
      } catch (error) {
        console.error("Error al cargar planteles:", error);
      }
    },

    async cargarCategorias() {
      try {
        const response = await this.$http.get("consultar.requisiciones");
        this.categorias = response.data;
      } catch (error) {
        console.error("Error al cargar categorías:", error);
      }
    },

    // Métodos para manejar eventos de los componentes hijos
    mostrarExito(mensaje) {
      this.$emit('actualizar'); // Emitir evento para actualizar datos en el padre
      this.$emit('mostrar-exito', mensaje);
    },

    mostrarError(mensaje) {
      this.$emit('mostrar-error', mensaje);
    },

    visualizarDocumentoProveedor() {
      const idproveedor = this.servicio.idproveedores;
      if (!idproveedor) {
        this.$emit('mostrar-error', 'No hay un proveedor asociado a este servicio');
        return;
      }

      this.cargar = true;
      this.selectedProveedor = this.proveedores.find(p => p.idproveedores === idproveedor);

      // Obtener la URL base
      let baseURL = this.$http.defaults.baseURL;
      if (baseURL.endsWith('/')) {
        baseURL = baseURL.slice(0, -1);
      }

      const url = `${baseURL}/proveedores.download.documento/${idproveedor}`;

      return
      // // Usar axios para obtener el documento
      // this.$http({
      //   url: url,
      //   method: 'GET',
      //   responseType: 'blob',
      // })
      // .then(response => {
      //   const blob = new Blob([response.data], { type: 'application/pdf' });
      //   this.pdfUrl = window.URL.createObjectURL(blob);
      //   this.dialogPdf = true;
      // })
      // .catch(error => {
      //   console.error('Error al cargar el documento:', error);
      //   this.$emit('mostrar-error', 'Error al cargar el documento. Por favor, inténtelo de nuevo.');
      // })
      // .finally(() => {
      //   this.cargar = false;
      // });
    },
    tieneDocumento(idproveedor) {
      return idproveedor ? true : false
    }
  },

  watch: {
    dialog(val) {
      if (val) {
        // Refrescar datos de los componentes hijos cuando se abre el diálogo
        this.$nextTick(() => {
          if (this.$refs.requisicionesComponent) {
            this.$refs.requisicionesComponent.cargarHistorialRequisiciones();
          }

          if (this.$refs.pagosComponent) {
            this.$refs.pagosComponent.cargarPagosProgramados();
          }

          // Cargar automáticamente el documento del proveedor si existe
          if (this.tieneDocumento(this.servicio.idproveedores)) {
            this.cargarDocumentoProveedor();
          }
        });
      }
    }
  }
}
</script>
<style scoped>
.pdf-preview-container {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}

.pdf-preview {
  background-color: #f5f5f5;
}
</style>
